import React, { useEffect, useState } from 'react';
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import './powerbi.css'
import { useRef } from 'react';
import SnackBar from '../../General/SnackBar';
import BackdropLoader from '../../General/Loader';
import { FetchUserAccessLocation } from 'API/PowerBI/api';

function ActivationReport() {
  const [accessToken, setAccessToken] = useState('');
  const [isLoading, setIsLoading] = useState(false)
  const [AlertMessage, setAlertMessage] = useState("")
  const [OpenAlert, setOpenAlert] = useState(false)
  const [AlertType, setAlertType] = useState(false)

  const [LocationDetails, setLocationDetails] = useState(false)


  const handleAlertOpen = (message, type) => {
    setAlertMessage(message)
    setAlertType(type)
    setOpenAlert(true)
  }

  const handleAlertClose = () => {
    setOpenAlert(false)
  }


  useEffect(() => {
    FetchUserAccessLocation(setIsLoading, setLocationDetails, handleAlertOpen)
  }, [])


  const [reportConfig, setReportConfig] = useState({
    tokenType: models.TokenType.Embed,
    visualName: "powerbi",
    height: 100,
    width: 100,
    accessToken: accessToken,
    type: "report",
    id: "aaac9405-5312-421e-adbb-94cc4f9e6db3",
    embedUrl: "https://app.powerbi.com/reportEmbed?reportId=aaac9405-5312-421e-adbb-94cc4f9e6db3&groupId=5f2b7be5-fa45-4627-a744-96acb75a9c5e&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLVdFU1QtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3d%22",
    settings: {
      filterPaneEnabled: false,

    },
    filters: [
      {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: { table: 'RAW_CSP_DUMP', column: 'Stateid' },
        operator: 'In',
        values: LocationDetails&&Array.isArray(LocationDetails.state_ids) ? LocationDetails.state_ids : [LocationDetails.state_ids],
        filterType: 1,
        displaySettings: {
          isLockedInViewMode: true,
          isHiddenInViewMode: true,
          displayName: 'Secret Filter'
        }
      }
    ]
  });

  const reportRef = useRef(null);


  console.log("LocationDetails", LocationDetails,reportConfig);



  useEffect(() => {
    // Fetch access token
    const fetchAccessToken = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BANKVERIFY_URL}powerbi-dashboard-access-token-api/accesstoken`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.status === 403) {
          throw new Error('CORS error: Access denied. Please check server configuration.');
        }
        if (!response.ok) {
          throw new Error('Failed to fetch access token');
        }

        const data = await response.json();
        setAccessToken(data.token);

        // Update reportConfig with the new access token
        setReportConfig(prevConfig => ({
          ...prevConfig,
          accessToken: data.token
        }));

      } catch (error) {
        console.error('Error fetching access token:', error);
      }
    };

    fetchAccessToken();

  }, []);




  return (
    <div className="tab-activation" style={{ height: '110%', width: '100%', display: 'flex', alignItems: 'stretch', justifyContent: 'stretch' }}>
      <SnackBar open={OpenAlert} type={AlertType} message={AlertMessage} handleClose={handleAlertClose} />
      <BackdropLoader open={isLoading} />
      {/* <div className="report-container" style={{ width: '120%', height: '90vh', maxWidth: '1900px', maxHeight: '800px' }}> */}
      {accessToken&&LocationDetails && (
        <PowerBIEmbed
          embedConfig={{
            tokenType: models.TokenType.Embed,
            visualName: "powerbi",
            height: 100,
            width: 100,
            accessToken: accessToken,
            type: "report",
            id: "aaac9405-5312-421e-adbb-94cc4f9e6db3",
            embedUrl: "https://app.powerbi.com/reportEmbed?reportId=aaac9405-5312-421e-adbb-94cc4f9e6db3&groupId=5f2b7be5-fa45-4627-a744-96acb75a9c5e&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLVdFU1QtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3d%22",
            settings: {
              filterPaneEnabled: false,
        
            },
            filters: [
              {
                $schema: 'http://powerbi.com/product/schema#basic',
                target: { table: 'RAW_CSP_DUMP', column: 'Stateid' },
                operator: 'In',
                values: LocationDetails&&Array.isArray(LocationDetails.stateids) ? LocationDetails.stateids : [LocationDetails.stateids],
                filterType: 1,
                displaySettings: {
                  isLockedInViewMode: true,
                  isHiddenInViewMode: true,
                  displayName: 'Secret Filter'
                }
              }
            ]
          }}
          containerRef={reportRef}
          cssClassName='powerbi-div'
        />
      )}
      {/* </div> */}
    </div>
  );
}
export default ActivationReport;
